import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class ChatIAService {
  async getChat(parametros) {
    const queryParams = parametros
      ? Object.keys(parametros)
          .map(
            (k) =>
              encodeURIComponent(k) + "=" + encodeURIComponent(parametros[k])
          )
          .join("&")
      : "";
    const rutas = await fetchWrapper.get(`${ruta}/chat?` + queryParams);
    return rutas;
  }

  async enviarMessage(value) {
    const rutas = await fetchWrapper.post(`${ruta}/consultar-ia`, value);
    return rutas;
  }
}
